<template>
    <div id="cardCollapseContainer">
        <div class="cardCollapsetitle">{{ title }}</div>
        <b-row class="p-2">
            <b-col cols="7">
                <div class="cardCollapseSubtitle">Score climat</div>
                <div class="cardCollapseSubtitle">Frais de gestion</div>
            </b-col>
            <b-col cols="1">
                <div
                    style="
            height: 100%;
            width: 5px;
            background: rgb(18, 18, 18);
            margin: auto;
          "
                />
            </b-col>
            <b-col cols="2">
                <div class="nb">{{ esg_score }}</div>
                <div class="nb">{{ fees }}</div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: ["title","esg_score",'fees']
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

#cardCollapseContainer {
    background: #242527 0% 0% no-repeat padding-box;
    border-radius: 20px;
    opacity: 1;
    .cardCollapsetitle {
        text-align: center;
        font: normal normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #ffffff;
        opacity: 1;
        border-bottom: 6px solid #121212;
    }
    .cardCollapseSubtitle {
        text-align: right;
        font: normal normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #ffffff;
    }

    .nb {
        text-align: left;
        font: normal normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: $purple_color;
        opacity: 1;
    }
}
</style>
